import { render, staticRenderFns } from "./pay-1.vue?vue&type=template&id=469720ac&scoped=true&"
import script from "./pay-1.vue?vue&type=script&lang=js&"
export * from "./pay-1.vue?vue&type=script&lang=js&"
import style0 from "./pay-1.vue?vue&type=style&index=0&id=469720ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469720ac",
  null
  
)

export default component.exports